(function () {
  /* gg-build 2026-09-29-r7 constant-pin-size stage-clamp */
  window.GG_BUILD = window.GG_BUILD || "2026-09-29-r7"; /* r7-constant-pin-size-stage-clamp */
  try { window.__GG_B64 = undefined; } catch (e) {}
  try {
    ["gg-places","GG_PLACES","gg_places","gaffle-guide-places","guide_places"].forEach(function (k) {
      try { localStorage.removeItem(k); sessionStorage.removeItem(k); } catch (e2) {}
    });
  } catch (e) {}
  var leftoverEmbed = document.getElementById("gaffle-guide-embed");
  if (leftoverEmbed) leftoverEmbed.remove();

  const root = document.getElementById("gaffle-guide");
  if (!root) return;
  root.setAttribute("data-gg-build", window.GG_BUILD);

  try {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes || [], function (n) {
          if (!n || n.nodeType !== 1) return;
          if (n.id === "gaffle-guide-embed") { n.remove(); return; }
          if (n.nodeName === "IFRAME") {
            var blob = ((n.getAttribute("src") || "") + " " + (n.srcdoc || "")).toLowerCase();
            if (blob.indexOf("gg-guide") !== -1 || blob.indexOf("gaffle-guide-embed") !== -1) n.remove();
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  const FALLBACK = window.GG_FALLBACK_PLACES || [];
  function readPlaces() {
    const el = document.getElementById("guide-places-data");
    let list = [];
    try { list = JSON.parse(el ? el.textContent : "[]"); } catch (e) { list = []; }
    // Always prefer the server-rendered metaobject JSON from this HTML document.
    // Never hydrate from localStorage or a previously cached place list.
    if (!Array.isArray(list) || !list.length) list = FALLBACK;
    return list.map(function (p) {
      const lat = Number(p.lat && p.lat.value != null ? p.lat.value : p.lat);
      const lon = Number(p.lon && p.lon.value != null ? p.lon.value : p.lon);
      return {
        type: String(p.type || p.place_type || "coffee"),
        coldDrip: p.coldDrip === true || p.cold_drip === true || p.coldDrip === "true" || p.cold_drip === "true",
        name: p.name || "",
        city: p.city || "",
        country: p.country || "",
        lat: lat,
        lon: lon,
        website: p.website || "",
        maps: p.maps || p.maps_url || "",
        notes: p.notes || ""
      };
    }).filter(function (p) { return p.name && isFinite(p.lat) && isFinite(p.lon); });
  }

  const LOCATIONS = readPlaces();
  const MAP = window.GG_MAP;
  const IMG = window.GG_IMG || {};
  if (!MAP || !MAP.paths) {
    root.innerHTML = '<p style="padding:32px;font:14px Inter,sans-serif">The Gaffle Guide map failed to load. Refresh the page.</p>';
    return;
  }

  function fitHeader() {
    const header = document.querySelector("sticky-header, .header-wrapper, #shopify-section-header, .section-header");
    const h = header ? Math.round(header.getBoundingClientRect().height) : 72;
    document.documentElement.style.setProperty("--gg-header-h", h + "px");
  }
  fitHeader();

  const NS = "http://www.w3.org/2000/svg";
  const svg = document.getElementById("gg-map");
  const viewport = document.getElementById("gg-viewport");
  const gCountries = document.getElementById("gg-countries");
  const gCountryLabels = document.getElementById("gg-country-labels");
  const gMarkers = document.getElementById("gg-markers");
  const gCities = document.getElementById("gg-cities");
  const gLeaders = document.getElementById("gg-leaders");
  const tooltip = document.getElementById("gg-tooltip");
  const card = document.getElementById("gg-card");
  const wrap = document.getElementById("gg-map-wrap");
  const stage = document.getElementById("gg-map-stage") || wrap;

  svg.setAttribute("viewBox", "0 0 " + MAP.W + " " + MAP.H);
  svg.setAttribute("preserveAspectRatio", "xMidYMid meet");

  function project(lon, lat) {
    const l = lon * Math.PI / 180, p = lat * Math.PI / 180;
    const p2 = p * p, p4 = p2 * p2;
    const x = l * (0.8707 - 0.131979 * p2 + p4 * (-0.013791 + p4 * (0.003971 * p2 - 0.001529 * p4)));
    const y = p * (1.007226 + p2 * (0.015085 + p4 * (-0.044475 + 0.028874 * p2 - 0.005916 * p4)));
    return [MAP.tx + MAP.k * x, MAP.ty - MAP.k * y];
  }

  for (let i = 0; i < MAP.paths.length; i++) {
    const p = document.createElementNS(NS, "path");
    p.setAttribute("d", MAP.paths[i]);
    p.setAttribute("class", "gg-country");
    gCountries.appendChild(p);
  }

  const countryTiers = [[], [], [], []];
  for (let i = 0; i < MAP.labels.length; i++) {
    const lb = MAP.labels[i];
    const tier = lb.a > 0.15 ? 0 : lb.a > 0.03 ? 1 : lb.a > 0.004 ? 2 : 3;
    countryTiers[tier].push(lb);
  }
  countryTiers.forEach(function (list) { list.sort(function (a, b) { return b.a - a.a; }); });
  const countryMeta = [];
  const countryTierEls = countryTiers.map(function (list, tier) {
    const g = document.createElementNS(NS, "g");
    for (let i = 0; i < list.length; i++) {
      const lb = list[i];
      const t = document.createElementNS(NS, "text");
      t.setAttribute("class", "gg-country-label");
      t.setAttribute("x", lb.x); t.setAttribute("y", lb.y);
      t.textContent = lb.n;
      g.appendChild(t);
      countryMeta.push({ el: t, x: lb.x, y: lb.y, tier: tier, w10: 0 });
    }
    gCountryLabels.appendChild(g);
    return g;
  });

  const cityTiers = [[], [], []];
  for (let i = 0; i < MAP.cities.length; i++) {
    const c = MAP.cities[i];
    const tier = c.p >= 5e6 ? 0 : c.p >= 2e6 ? 1 : 2;
    cityTiers[tier].push(c);
  }
  const cityMeta = [];
  const cityTierEls = cityTiers.map(function (list, tier) {
    const g = document.createElementNS(NS, "g");
    for (let i = 0; i < list.length; i++) {
      const c = list[i];
      const node = document.createElementNS(NS, "g");
      node.setAttribute("transform", "translate(" + c.x + "," + c.y + ")");
      node.appendChild(document.createElementNS(NS, "circle"));
      const t = document.createElementNS(NS, "text");
      t.setAttribute("dx", "0.5em"); t.setAttribute("dy", "0.34em");
      t.textContent = c.n;
      node.appendChild(t);
      g.appendChild(node);
      cityMeta.push({ el: node, textEl: t, x: c.x, y: c.y, tier: tier, w10: 0 });
    }
    gCities.appendChild(g);
    return g;
  });

  gCountryLabels.setAttribute("font-size", 10);
  gCities.setAttribute("font-size", 10);
  for (let i = 0; i < countryMeta.length; i++) countryMeta[i].w10 = countryMeta[i].el.getComputedTextLength();
  for (let i = 0; i < cityMeta.length; i++) cityMeta[i].w10 = cityMeta[i].textEl.getComputedTextLength();

  function svgImage(src, w0, h0, h) {
    const w = h * w0 / h0;
    const el = document.createElementNS(NS, "image");
    el.setAttribute("href", src);
    el.setAttribute("width", w); el.setAttribute("height", h);
    el.setAttribute("x", -w / 2); el.setAttribute("y", -h / 2);
    return { el: el, w: w, h: h };
  }

  function cosignMark(size) {
    var g = document.createElementNS(NS, "g");
    var s0 = size;
    var bg = document.createElementNS(NS, "rect");
    bg.setAttribute("x", -s0 / 2);
    bg.setAttribute("y", -s0 / 2);
    bg.setAttribute("width", s0);
    bg.setAttribute("height", s0);
    bg.setAttribute("rx", Math.max(2, s0 * 0.16));
    bg.setAttribute("fill", "#AE1F2E");
    g.appendChild(bg);
    if (IMG.favicon) {
      var im = svgImage(IMG.favicon, 64, 64, s0);
      g.appendChild(im.el);
    } else {
      var t = document.createElementNS(NS, "text");
      t.setAttribute("text-anchor", "middle");
      t.setAttribute("dominant-baseline", "central");
      t.setAttribute("y", s0 * 0.06);
      t.setAttribute("fill", "#fff");
      t.setAttribute("font-size", s0 * 0.72);
      t.setAttribute("font-weight", "800");
      t.setAttribute("font-style", "italic");
      t.setAttribute("font-family", "Georgia, 'Times New Roman', serif");
      t.textContent = "G";
      g.appendChild(t);
    }
    return g;
  }

  function markerShape(loc) {
    const g = document.createElementNS(NS, "g");
    g.setAttribute("class", "shape");
    let labelX = 14, hitR = 18;
    if (loc.type === "gaffle") {
      const im = svgImage(IMG.logo, 338, 120, 30);
      g.appendChild(im.el);
      labelX = 0; hitR = Math.max(26, im.w / 2 + 4);
    } else if (loc.type === "hotel") {
      const left = document.createElementNS(NS, "path");
      left.setAttribute("d", "M0,-11 L-14,9.5 L-4.2,9.5 Z");
      left.setAttribute("fill", "#AE1F2E");
      g.appendChild(left);
      const right = document.createElementNS(NS, "path");
      right.setAttribute("d", "M0,-11 L-4.2,9.5 L14,9.5 Z");
      right.setAttribute("fill", "#fff");
      right.setAttribute("stroke", "#AE1F2E");
      right.setAttribute("stroke-width", "2.2");
      right.setAttribute("stroke-linejoin", "round");
      g.appendChild(right);
      labelX = 18; hitR = 24;
    } else if (loc.coldDrip) {
      g.appendChild(svgImage(IMG.tower, 54, 180, 44).el);
      var badge = cosignMark(11);
      badge.setAttribute("transform", "translate(12,-16)");
      g.appendChild(badge);
      labelX = 14; hitR = 26;
    } else {
      g.appendChild(cosignMark(20));
      labelX = 16; hitR = 24;
    }
    return { shape: g, labelX: labelX, hitR: hitR };
  }

  function tagsFor(loc) {
    if (loc.type === "gaffle") return ["gaffle"];
    if (loc.type === "hotel") return ["hotel"];
    var tags = ["cosign"];
    if (loc.coldDrip) tags.push("colddrip");
    return tags;
  }
  function isVisible(loc) {
    var tags = tagsFor(loc);
    if (tags.indexOf("gaffle") !== -1) return true;
    for (var i = 0; i < tags.length; i++) {
      if (filters[tags[i]]) return true;
    }
    return false;
  }

  const markerEls = [];
  const ordered = LOCATIONS.slice().sort(function (a, b) {
    return (a.type === "gaffle") - (b.type === "gaffle");
  });

  for (let i = 0; i < ordered.length; i++) {
    const loc = ordered[i];
    const xy = project(loc.lon, loc.lat);
    const g = document.createElementNS(NS, "g");
    g.setAttribute("class", "gg-marker");
    g.dataset.tags = tagsFor(loc).join(" ");
    const ms = markerShape(loc);
    const hit = document.createElementNS(NS, "circle");
    hit.setAttribute("class", "hit"); hit.setAttribute("r", ms.hitR);
    g.appendChild(hit);
    g.appendChild(ms.shape);
    let labelEl = null;
    if (loc.type !== "gaffle") {
      labelEl = document.createElementNS(NS, "text");
      labelEl.setAttribute("class", "gg-city-label");
      labelEl.setAttribute("x", ms.labelX); labelEl.setAttribute("y", 3.5);
      labelEl.textContent = loc.name;
      g.appendChild(labelEl);
    }
    g.addEventListener("pointerenter", function (e) { showTooltip(loc, e); });
    g.addEventListener("pointermove", function (e) { moveTooltip(e); });
    g.addEventListener("pointerleave", hideTooltip);
    g.addEventListener("click", function (e) {
      e.stopPropagation();
      openCard(loc, e);
    });
    const lLine = document.createElementNS(NS, "line");
    lLine.setAttribute("class", "gg-leader-line");
    lLine.style.display = "none";
    gLeaders.appendChild(lLine);
    const lDot = document.createElementNS(NS, "circle");
    lDot.setAttribute("class", "gg-leader-dot");
    lDot.style.display = "none";
    gLeaders.appendChild(lDot);
    gMarkers.appendChild(g);
    markerEls.push({
      el: g, hitEl: hit, x: xy[0], y: xy[1], loc: loc, labelEl: labelEl, labelX: ms.labelX,
      labelW: labelEl ? labelEl.getComputedTextLength() : 0,
      npx: 0, npy: 0, tnpx: 0, tnpy: 0, lLine: lLine, lDot: lDot
    });
  }

  const chipIconCold = document.getElementById("gg-chip-icon-colddrip");
  if (chipIconCold && IMG.tower) chipIconCold.src = IMG.tower;
  const chipIconCosign = document.getElementById("gg-chip-icon-cosign");
  if (chipIconCosign && IMG.favicon) chipIconCosign.src = IMG.favicon;

  function localXY(e) {
    /* Position relative to #gg-map-stage (overflow clip parent for card/tooltip). */
    const r = stage.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  }
  function showTooltip(loc, e) {
    tooltip.innerHTML = loc.name + ' &nbsp;<span class="sub">' + loc.city + ", " + loc.country + "</span>";
    tooltip.style.opacity = 1;
    moveTooltip(e);
  }
  function moveTooltip(e) {
    const p = localXY(e);
    const pad = 12;
    const tw = tooltip.offsetWidth || 0;
    const th = tooltip.offsetHeight || 0;
    const sw = stage.clientWidth;
    const sh = stage.clientHeight;
    /* Default CSS: translate(-50%, calc(-100% - 14px)) — above cursor. Flip below near top. */
    var above = (p.y - th - 14) >= pad;
    if (!above && (p.y + 14 + th + pad) > sh) above = true; /* prefer above if below also clips */
    var lx = p.x;
    var half = tw / 2;
    if (lx - half < pad) lx = pad + half;
    if (lx + half > sw - pad) lx = Math.max(pad + half, sw - pad - half);
    tooltip.style.left = lx + "px";
    tooltip.style.top = p.y + "px";
    tooltip.style.transform = above
      ? "translate(-50%, calc(-100% - 14px))"
      : "translate(-50%, 14px)";
  }
  function hideTooltip() { tooltip.style.opacity = 0; }

  var lastOpenAt = 0;
  function openCard(loc, e) {
    var now = Date.now();
    if (now - lastOpenAt < 280 && card.style.display === "block") return;
    lastOpenAt = now;
    document.getElementById("gg-card-kicker").textContent =
      loc.type === "gaffle" ? "Headquarters" :
      loc.type === "hotel" ? "Hotel" : "Coffee Shop";
    document.getElementById("gg-card-name").textContent = loc.name;
    document.getElementById("gg-card-place").textContent = loc.city + ", " + loc.country;
    const notesEl = document.getElementById("gg-card-notes");
    if (loc.notes) {
      notesEl.textContent = loc.notes;
      notesEl.style.display = "";
    } else {
      notesEl.textContent = "";
      notesEl.style.display = "none";
    }
    const tags = document.getElementById("gg-card-tags");
    tags.innerHTML = "";
    function addTag(cls, text) {
      const tag = document.createElement("span");
      tag.className = "gg-tag " + cls;
      tag.textContent = text;
      tags.appendChild(tag);
    }
    if (loc.type === "gaffle") addTag("cosign", "★ Home of Gaffle");
    else if (loc.type === "hotel") addTag("hotel", "Gaffle Guide Hotel");
    else {
      addTag("cosign", "★ Gaffle Cosign");
      if (loc.coldDrip) addTag("colddrip", "Serves Genuine Cold Drip");
    }
    const links = document.getElementById("gg-card-links");
    links.innerHTML = "";
    if (loc.website) {
      const a = document.createElement("a");
      a.href = loc.website; a.target = "_blank"; a.rel = "noopener";
      a.className = "primary"; a.textContent = "Website ↗";
      links.appendChild(a);
    }
    if (loc.maps) {
      const a = document.createElement("a");
      a.href = loc.maps; a.target = "_blank"; a.rel = "noopener";
      a.textContent = "Maps ↗";
      links.appendChild(a);
    }
    card.style.display = "block";
    const p = localXY(e);
    const cw = card.offsetWidth, ch = card.offsetHeight, pad = 12;
    /* Clamp against stage (overflow:hidden parent), not outer #gaffle-guide. */
    const sw = stage.clientWidth, sh = stage.clientHeight;
    let cx = p.x + 18, cy = p.y - 20;
    /* Horizontal: prefer right of pin, flip left, then clamp into stage. */
    if (cx + cw + pad > sw) cx = p.x - cw - 18;
    if (cx < pad) cx = pad;
    if (cx + cw + pad > sw) cx = Math.max(pad, sw - cw - pad);
    /* Vertical: prefer near pin; if overflows bottom, place fully above pin; then clamp. */
    if (cy + ch + pad > sh) cy = p.y - ch - 18;
    if (cy < pad) cy = pad;
    if (cy + ch + pad > sh) cy = Math.max(pad, sh - ch - pad);
    card.style.left = cx + "px";
    card.style.top = cy + "px";
  }
  function closeCard() { card.style.display = "none"; }
  card.querySelector(".close").addEventListener("click", closeCard);

  const filters = { cosign: true, colddrip: true, hotel: true };
  Object.keys(filters).forEach(function (key) {
    const n = LOCATIONS.filter(function (l) { return tagsFor(l).indexOf(key) !== -1; }).length;
    const countEl = document.getElementById("gg-count-" + key);
    if (countEl) countEl.textContent = n;
    const chip = document.getElementById("gg-chip-" + key);
    if (!chip) return;
    chip.addEventListener("click", function () {
      var keys = Object.keys(filters);
      var allOn = keys.every(function (k) { return filters[k]; });
      var onCount = keys.filter(function (k) { return filters[k]; }).length;
      if (allOn) {
        keys.forEach(function (k) {
          filters[k] = (k === key);
          var c = document.getElementById("gg-chip-" + k);
          if (c) c.classList.toggle("off", k !== key);
        });
      } else if (filters[key] && onCount === 1) {
        keys.forEach(function (k) {
          filters[k] = true;
          var c = document.getElementById("gg-chip-" + k);
          if (c) c.classList.remove("off");
        });
      } else {
        filters[key] = !filters[key];
        chip.classList.toggle("off", !filters[key]);
        if (!filters.cosign && !filters.colddrip && !filters.hotel) {
          filters[key] = true;
          chip.classList.remove("off");
        }
      }
      applyFilters();
    });
  });
  function applyFilters() {
    for (let i = 0; i < markerEls.length; i++) {
      const m = markerEls[i];
      m.el.style.display = isVisible(m.loc) ? "" : "none";
    }
    computeSpread();
    render();
    declutterStatics();
    closeCard();
  }

  /* ---------- pan & zoom: dt-damped, coalesced wheel, no settle snap ---------- */
  let k = 1, tx = 0, ty = 0;
  let tk = 1, ttx = 0, tty = 0;
  const K_MIN = 1, K_MAX = 200;
  const DAMP = 11;
  let animating = false;
  let lastT = 0;
  let pendingZoom = 1, pendingZX = 0, pendingZY = 0;
  let spreadClock = 0;

  function clampPanTarget() {
    const mw = MAP.W * tk, mh = MAP.H * tk;
    const minX = -(mw - MAP.W * 0.15), maxX = MAP.W * 0.85;
    const minY = -(mh - MAP.H * 0.15), maxY = MAP.H * 0.85;
    ttx = Math.min(maxX, Math.max(minX, ttx));
    tty = Math.min(maxY, Math.max(minY, tty));
  }

  function requestRender() {
    if (!animating) {
      animating = true;
      lastT = 0;
      requestAnimationFrame(tick);
    }
  }

  function tick(now) {
    if (pendingZoom !== 1) {
      applyZoomAt(pendingZX, pendingZY, pendingZoom);
      pendingZoom = 1;
    }
    const dt = lastT ? Math.min(0.033, (now - lastT) / 1000) : 0.016;
    lastT = now;
    const a = 1 - Math.exp(-DAMP * dt);
    k += (tk - k) * a;
    tx += (ttx - tx) * a;
    ty += (tty - ty) * a;
    let settled = Math.abs(tk - k) < 0.0015 * Math.max(tk, 1)
      && Math.abs(ttx - tx) < 0.2 && Math.abs(tty - ty) < 0.2;
    for (let i = 0; i < markerEls.length; i++) {
      const m = markerEls[i];
      m.npx += (m.tnpx - m.npx) * a;
      m.npy += (m.tnpy - m.npy) * a;
      if (Math.abs(m.tnpx - m.npx) > 0.35 || Math.abs(m.tnpy - m.npy) > 0.35) settled = false;
    }
    spreadClock += dt;
    if (spreadClock > 0.05) { computeSpread(); spreadClock = 0; }
    render(!settled);
    if (settled) {
      animating = false;
      computeSpread();
      render(false);
      declutterStatics();
      return;
    }
    requestAnimationFrame(tick);
  }

  function render(zooming) {
    viewport.setAttribute("transform", "translate(" + tx + "," + ty + ") scale(" + k + ")");
    const s = pinScreenScale(k);
    const sLabel = labelScreenScale(k);
    const sg = Math.min(1.35, 1.05 * Math.pow(k, 0.08));
    const ssR = svgScale();
    const hitLocal = 22 / Math.max(0.001, s * ssR);
    for (let i = 0; i < markerEls.length; i++) {
      const m = markerEls[i];
      const f = (m.loc.type === "gaffle" ? sg : s) / k;
      if (m.hitEl) m.hitEl.setAttribute("r", Math.max(20, hitLocal));
      if (m.labelEl) m.labelEl.setAttribute("font-size", 11 * (sLabel / s));
      const dx = m.npx / (k * ssR), dy = m.npy / (k * ssR);
      m.el.setAttribute("transform", "translate(" + (m.x + dx) + "," + (m.y + dy) + ") scale(" + f + ")");
      const show = Math.hypot(m.npx, m.npy) > 6 && m.el.style.display !== "none";
      m.lLine.style.display = show ? "" : "none";
      m.lDot.style.display = show ? "" : "none";
      if (show) {
        m.lLine.setAttribute("x1", m.x); m.lLine.setAttribute("y1", m.y);
        m.lLine.setAttribute("x2", m.x + dx); m.lLine.setAttribute("y2", m.y + dy);
        m.lDot.setAttribute("cx", m.x); m.lDot.setAttribute("cy", m.y);
        m.lDot.setAttribute("r", 2.4 / k);
      }
    }
    const ramp = function (a, b) { return Math.max(0, Math.min(1, (k - a) / (b - a))); };
    gCountryLabels.setAttribute("font-size", (9.5 + 2.4 * Math.log(k)) / k);
    gCities.setAttribute("font-size", (8.5 + 1.7 * Math.log(k)) / k);
    svg.style.setProperty("--cr", (2.0 / k) + "px");
    countryOp = [1, ramp(1.2, 2.1), ramp(2.6, 4.2), ramp(7, 9.5)];
    cityOp = [ramp(1.8, 2.8), ramp(3.4, 5.0), ramp(5.8, 8.0)];
    countryTierEls.forEach(function (g, i) { g.setAttribute("opacity", countryOp[i]); });
    cityTierEls.forEach(function (g, i) { g.setAttribute("opacity", cityOp[i]); });
    if (!zooming) declutterLabels(s);
  }

  let countryOp = [1, 0, 0, 0], cityOp = [0, 0, 0];
  const hit = function (r, p) {
    return r.x < p.x + p.w && r.x + r.w > p.x && r.y < p.y + p.h && r.y + r.h > p.y;
  };

  function declutterLabels(s) {
    const ss = svgScale();
    const placed = [];
    const pad = 3;
    for (let i = 0; i < markerEls.length; i++) {
      const m = markerEls[i];
      if (m.el.style.display === "none") continue;
      const u = s * ss;
      const px = (tx + m.x * k) * ss + m.npx;
      const py = (ty + m.y * k) * ss + m.npy;
      let r = null, collides = false;
      if (m.labelEl) {
        const h = 12 * u + pad * 2, w = m.labelW * u + pad * 2, y = py - 6 * u - pad;
        r = { x: px + m.labelX * u - pad, y: y, w: w, h: h };
        collides = placed.some(function (p) { return hit(r, p); });
        if (!collides) {
          m.labelEl.setAttribute("x", m.labelX);
          m.labelEl.setAttribute("text-anchor", "start");
        } else {
          const rl = { x: px - m.labelX * u - m.labelW * u - pad, y: y, w: w, h: h };
          if (!placed.some(function (p) { return hit(rl, p); })) {
            m.labelEl.setAttribute("x", -m.labelX);
            m.labelEl.setAttribute("text-anchor", "end");
            r = rl; collides = false;
          }
        }
        m.labelEl.style.visibility = collides ? "hidden" : "visible";
      }
      placed.push({ x: px - 12 * u, y: py - 14 * u, w: 24 * u, h: 28 * u });
      if (r && !collides) placed.push(r);
    }
    return placed;
  }

  function computeSpread() {
    const ss = svgScale();
    for (let i = 0; i < markerEls.length; i++) { markerEls[i].tnpx = 0; markerEls[i].tnpy = 0; }
    const strength = Math.max(0, Math.min(1, (k - 2) / 4));
    if (strength === 0) return;
    const pts = [];
    for (let i = 0; i < markerEls.length; i++) {
      const m = markerEls[i];
      if (m.el.style.display === "none") continue;
      pts.push({ m: m, px: (tx + m.x * k) * ss, py: (ty + m.y * k) * ss });
    }
    const TH = 30;
    const used = new Array(pts.length).fill(false);
    for (let i = 0; i < pts.length; i++) {
      if (used[i]) continue;
      const c = [pts[i]]; used[i] = true;
      let grew = true;
      while (grew) {
        grew = false;
        for (let j = 0; j < pts.length; j++) {
          if (used[j]) continue;
          if (c.some(function (q) { return Math.hypot(q.px - pts[j].px, q.py - pts[j].py) < TH; })) {
            c.push(pts[j]); used[j] = true; grew = true;
          }
        }
      }
      if (c.length < 2) continue;
      const cx = c.reduce(function (a, p) { return a + p.px; }, 0) / c.length;
      const cy = c.reduce(function (a, p) { return a + p.py; }, 0) / c.length;
      const R = c.length === 2 ? 18 : 15 + c.length * 5.5;
      c.forEach(function (p) { p.ang = Math.atan2(p.py - cy, p.px - cx) || 0; });
      c.sort(function (a, b) { return a.ang - b.ang; });
      const start = c[0].ang;
      c.forEach(function (p, idx) {
        if (p.m.loc.type === "gaffle") return;
        const ang = start + idx * 2 * Math.PI / c.length;
        p.m.tnpx = (cx + R * Math.cos(ang) - p.px) * strength;
        p.m.tnpy = (cy + R * Math.sin(ang) - p.py) * strength;
      });
    }
  }

  function declutterStatics() {
    computeSpread();
    const converged = markerEls.every(function (m) {
      return Math.abs(m.tnpx - m.npx) < 0.5 && Math.abs(m.tnpy - m.npy) < 0.5;
    });
    if (!converged) { requestRender(); return; }
    render(false);
    const ss = svgScale();
    const s = pinScreenScale(k);
    const placed = declutterLabels(s);
    const cf = (9.5 + 2.4 * Math.log(k)) * ss;
    for (let i = 0; i < countryMeta.length; i++) {
      const m = countryMeta[i];
      if (countryOp[m.tier] <= 0.02) { m.el.style.visibility = "hidden"; continue; }
      const w = m.w10 / 10 * cf * 1.16, h = cf * 1.25;
      const px = (tx + m.x * k) * ss, py = (ty + m.y * k) * ss;
      const r = { x: px - w / 2 - 2, y: py - h / 2 - 2, w: w + 4, h: h + 4 };
      const collides = placed.some(function (p) { return hit(r, p); });
      m.el.style.visibility = collides ? "hidden" : "visible";
      if (!collides) placed.push(r);
    }
    const ff = (8.5 + 1.7 * Math.log(k)) * ss;
    for (let i = 0; i < cityMeta.length; i++) {
      const m = cityMeta[i];
      if (cityOp[m.tier] <= 0.02) { m.el.style.visibility = "hidden"; continue; }
      const w = m.w10 / 10 * ff + ff * 0.8, h = ff * 1.25;
      const px = (tx + m.x * k) * ss, py = (ty + m.y * k) * ss;
      const r = { x: px - ff * 0.3, y: py - h / 2, w: w, h: h };
      const collides = placed.some(function (p) { return hit(r, p); });
      m.el.style.visibility = collides ? "hidden" : "visible";
      if (!collides) placed.push(r);
    }
  }

  let svgRect = svg.getBoundingClientRect();
  function updateSvgRect() { svgRect = svg.getBoundingClientRect(); }
  function svgScale() { return Math.min(svgRect.width / MAP.W, svgRect.height / MAP.H); }
  /* Keep on-screen pin/logo/title size roughly constant across zoom (f = s/k cancels viewport scale). */
  function pinScreenScale(zoomK) { return Math.min(1.85, 1.55 * Math.pow(zoomK, 0.08)); }
  function labelScreenScale(zoomK) { return Math.min(2.2, 1.85 * Math.pow(zoomK, 0.08)); }
  function svgOffset() {
    const s = svgScale();
    return [svgRect.left + (svgRect.width - MAP.W * s) / 2, svgRect.top + (svgRect.height - MAP.H * s) / 2, s];
  }

  function applyZoomAt(clientX, clientY, factor) {
    const off = svgOffset();
    const ux = (clientX - off[0]) / off[2], uy = (clientY - off[1]) / off[2];
    const k2 = Math.min(K_MAX, Math.max(K_MIN, tk * factor));
    const f = k2 / tk;
    ttx = ux - (ux - ttx) * f;
    tty = uy - (uy - tty) * f;
    tk = k2;
    clampPanTarget();
  }

  function zoomAt(clientX, clientY, factor) {
    applyZoomAt(clientX, clientY, factor);
    requestRender();
  }

  function wheelFactor(e) {
    let dy = e.deltaY;
    if (e.deltaMode === 1) dy *= 16;
    if (e.deltaMode === 2) dy *= 800;
    dy = Math.max(-72, Math.min(72, dy));
    return Math.exp(-dy * 0.00205);
  }

  wrap.addEventListener("wheel", function (e) {
    e.preventDefault();
    pendingZoom *= wheelFactor(e);
    pendingZX = e.clientX;
    pendingZY = e.clientY;
    requestRender();
  }, { passive: false });

  const pointers = new Map();
  let pinchDist = 0, dragMoved = false;
  let ignorePan = false;
  const EDGE_PX = 28;
  const TAP_MOVE = 10;
  let touchPan = false;
  let touchFromEdge = false;
  let touchSX = 0, touchSY = 0;

  function wrapLocalX(clientX) {
    return clientX - wrap.getBoundingClientRect().left;
  }
  function isEdgeStart(clientX) {
    return wrapLocalX(clientX) < EDGE_PX;
  }
  function markerAtScreen(clientX, clientY) {
    const off = svgOffset();
    const ss = off[2];
    let best = null, bestD = 28;
    for (let i = 0; i < markerEls.length; i++) {
      const m = markerEls[i];
      if (m.el.style.display === "none") continue;
      const px = off[0] + (tx + m.x * k) * ss + m.npx;
      const py = off[1] + (ty + m.y * k) * ss + m.npy;
      const d = Math.hypot(clientX - px, clientY - py);
      if (d < bestD) { bestD = d; best = m; }
    }
    return best;
  }

  wrap.addEventListener("pointerdown", function (e) {
    if (e.target.closest("#gg-card") || e.target.closest(".gg-zoom") || e.target.closest(".gg-chip")) return;
    if (isEdgeStart(e.clientX)) {
      ignorePan = true;
      return;
    }
    ignorePan = false;
    pointers.set(e.pointerId, [e.clientX, e.clientY]);
    try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
    wrap.classList.add("dragging");
    dragMoved = false;
    if (pointers.size === 2) {
      const pts = Array.from(pointers.values());
      pinchDist = Math.hypot(pts[0][0] - pts[1][0], pts[0][1] - pts[1][1]);
    }
  });
  wrap.addEventListener("pointermove", function (e) {
    if (ignorePan) return;
    if (!pointers.has(e.pointerId)) return;
    const prev = pointers.get(e.pointerId);
    pointers.set(e.pointerId, [e.clientX, e.clientY]);
    if (pointers.size === 1) {
      const s = svgScale();
      ttx += (e.clientX - prev[0]) / s;
      tty += (e.clientY - prev[1]) / s;
      clampPanTarget();
      tx = ttx; ty = tty; k = tk;
      if (Math.abs(e.clientX - prev[0]) + Math.abs(e.clientY - prev[1]) > 1) dragMoved = true;
      render(true);
    } else if (pointers.size === 2) {
      const pts = Array.from(pointers.values());
      const d = Math.hypot(pts[0][0] - pts[1][0], pts[0][1] - pts[1][1]);
      const cx = (pts[0][0] + pts[1][0]) / 2, cy = (pts[0][1] + pts[1][1]) / 2;
      if (pinchDist > 0) {
        applyZoomAt(cx, cy, d / pinchDist);
        k = tk; tx = ttx; ty = tty;
        render(true);
      }
      pinchDist = d;
    }
  });
  function endPointer(e) {
    pointers.delete(e.pointerId);
    if (pointers.size < 2) pinchDist = 0;
    if (pointers.size === 0) {
      wrap.classList.remove("dragging");
      var wasEdge = ignorePan;
      ignorePan = false;
      if (!dragMoved && !wasEdge) {
        var hitM = markerAtScreen(e.clientX, e.clientY);
        if (hitM) {
          openCard(hitM.loc, e);
          return;
        }
        if (!e.target.closest("#gg-card")) closeCard();
      }
      declutterStatics();
    }
  }
  wrap.addEventListener("pointerup", endPointer);
  wrap.addEventListener("pointercancel", endPointer);

  wrap.addEventListener("touchstart", function (e) {
    if (!e.touches || !e.touches.length) return;
    var t = e.touches[0];
    touchSX = t.clientX; touchSY = t.clientY;
    touchFromEdge = isEdgeStart(t.clientX);
    touchPan = false;
  }, { passive: true, capture: true });
  wrap.addEventListener("touchmove", function (e) {
    if (!e.touches || !e.touches.length) return;
    if (touchFromEdge) return;
    var t = e.touches[0];
    var dist = Math.abs(t.clientX - touchSX) + Math.abs(t.clientY - touchSY);
    if (dist > TAP_MOVE) {
      touchPan = true;
      if (e.cancelable) e.preventDefault();
    }
  }, { passive: false, capture: true });
  wrap.addEventListener("touchend", function (e) {
    if (touchFromEdge || touchPan) return;
    var t = (e.changedTouches && e.changedTouches[0]) || null;
    if (!t) return;
    var hitM = markerAtScreen(t.clientX, t.clientY);
    if (hitM) {
      e.preventDefault();
      openCard(hitM.loc, t);
    }
  }, { passive: false, capture: true });
  wrap.style.touchAction = "none";
  wrap.style.overscrollBehavior = "none";
  wrap.style.overscrollBehaviorX = "none";
  wrap.style.overflow = "hidden";
  wrap.style.clipPath = "inset(0)";

  function zoomTowardCenter(factor) {
    const r = svgRect;
    zoomAt(r.left + r.width / 2, r.top + r.height / 2, factor);
  }
  document.getElementById("gg-zoom-in").addEventListener("click", function () { zoomTowardCenter(1.28); });
  document.getElementById("gg-zoom-out").addEventListener("click", function () { zoomTowardCenter(1 / 1.28); });
  document.getElementById("gg-zoom-reset").addEventListener("click", function () {
    tk = 1; ttx = 0; tty = 0; requestRender(); closeCard();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCard(); });

  function syncFiltersFromDom() {
    ["cosign", "colddrip", "hotel"].forEach(function (key) {
      var chip = document.getElementById("gg-chip-" + key);
      if (!chip) return;
      filters[key] = !chip.classList.contains("off");
    });
    applyFilters();
  }
  function onPageShow(e) {
    syncFiltersFromDom();
    if (e && e.persisted) {
      updateSvgRect();
      render(false);
      declutterStatics();
    }
  }
  window.addEventListener("pageshow", onPageShow);
  window.addEventListener("popstate", function () { syncFiltersFromDom(); });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") syncFiltersFromDom();
  });

  render(false);
  declutterStatics();
  window.addEventListener("resize", function () {
    fitHeader();
    updateSvgRect();
    render(false);
    declutterStatics();
  });
})();
